module.exports = __webpack_public_path__ + "static/eco-logo-main-new-67913e098e7b1a7afdedfda293bb4d8f.svg";